import { type FormData } from 'domains/account-management/components/account-form/utils/AccountForm.types'

type RoleIsDisabledConfig = {
  [key in string]: (args: { formData: FormData }) => boolean
}

const hasPrimaryRoleSelected = roles => roles.filter(role => role.roleRank === 'primary').length > 0
// config to define method to call to determine if a role should be disabled in the form
// the key is the role_slug

const roleIsDisabledConfig: RoleIsDisabledConfig = {
  insights_portal: ({ formData }) => !hasPrimaryRoleSelected(formData['roles']),
  retailer_tools_oncall: ({ formData }) => !hasPrimaryRoleSelected(formData['roles']),
  legacy_read_only: ({ formData }) => !hasPrimaryRoleSelected(formData['roles']),
}

export const accountManagementIsRoleDisabled = (slug: string, formData: FormData): boolean => {
  const isDisabledCheck = roleIsDisabledConfig[slug]
  return isDisabledCheck ? isDisabledCheck({ formData }) : false
}
